var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-col",class:{'v-col-half': !_vm.isWhole}},[_c('div',{staticClass:"v-col-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"v-col-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }